<template>
  <div class="content">
    <b-container class="bv-example-row">
      <b-row>
        <b-col><router-link to="/list">キャラクター</router-link></b-col>
        <b-col><router-link to="/world">異世界</router-link></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'list-nav',
}
</script>

<style lang="scss" scoped>
.bv-example-row {
  div div {
    border: 2px solid #CCC;
  }
}
</style>
